import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Icon } from "@chakra-ui/react";
import Span from "@inspire/ui/chakra/Span";
import { StarBookmarkIcon, BulbIcon } from "@inspire/ui/icons";
var Frame = function(_param) /*#__PURE__*/ {
    var label = _param.label, children = _param.children, labelProps = _param.labelProps, boxProps = _object_without_properties(_param, [
        "label",
        "children",
        "labelProps"
    ]);
    return _jsxs(Box, _object_spread_props(_object_spread({
        pos: "relative",
        border: "1px solid var(--chakra-colors-gray-200)",
        borderRadius: 4
    }, boxProps), {
        children: [
            /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
                pos: "absolute",
                top: -3,
                background: "white",
                px: 3
            }, labelProps), {
                children: label
            })),
            children
        ]
    }));
};
export var IconFrame = function(_param) /*#__PURE__*/ {
    var children = _param.children, icon = _param.icon, iconProps = _param.iconProps, label = _param.label, labelProps = _param.labelProps, boxProps = _object_without_properties(_param, [
        "children",
        "icon",
        "iconProps",
        "label",
        "labelProps"
    ]);
    return _jsx(Frame, _object_spread_props(_object_spread({
        label: /*#__PURE__*/ _jsxs(Flex, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Icon, _object_spread({
                    as: icon,
                    mr: 1.5,
                    boxSize: 5
                }, iconProps)),
                label
            ]
        }),
        labelProps: _object_spread({
            pl: 2
        }, labelProps),
        p: 4
    }, boxProps), {
        children: children
    }));
};
export var SummaryFrame = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(IconFrame, _object_spread_props(_object_spread({
        icon: StarBookmarkIcon,
        label: "En r\xe9sum\xe9",
        iconProps: {
            color: "red.500"
        }
    }, rest), {
        children: children
    }));
};
export var ProfTipFrame = function(_param) /*#__PURE__*/ {
    var children = _param.children, _isShortVersion = _param.isShortVersion, isShortVersion = _isShortVersion === void 0 ? false : _isShortVersion, rest = _object_without_properties(_param, [
        "children",
        "isShortVersion"
    ]);
    return _jsx(IconFrame, _object_spread_props(_object_spread({
        icon: BulbIcon,
        label: isShortVersion ? /*#__PURE__*/ _jsx(Span, {
            children: "Info prof"
        }) : /*#__PURE__*/ _jsxs(Span, {
            children: [
                "Information professeur",
                " ",
                /*#__PURE__*/ _jsx(Span, {
                    color: "gray.500",
                    fontSize: "sm",
                    ml: 1,
                    display: [
                        "none",
                        "inline"
                    ],
                    children: "(visible uniquement par vous)"
                })
            ]
        }),
        border: "1px solid",
        borderColor: "yellow.500",
        fontStyle: "italic",
        backgroundColor: "yellow.50",
        p: 0,
        labelProps: {
            py: 1,
            ml: 4,
            top: -4,
            borderRadius: 4,
            backgroundColor: "yellow.50",
            border: "1px solid",
            borderColor: "yellow.500"
        }
    }, rest), {
        children: /*#__PURE__*/ _jsx(Box, {
            p: 4,
            children: children
        })
    }));
};
export default Frame;
